module.exports = __webpack_public_path__ + "static/img/close-icon.a7238d8e.png";